import { createI18nText } from '@hilma/netina2all';

const profileNavigationText = createI18nText({
	he: {
		hi: 'שלום',
		pd: 'פרטים אישיים',
		purchases: 'הזמנות',
		station: 'תחנות חלוקה',
		stationM: 'ניהול תחנה',
		associationM: 'ניהול עמותה'
	},
	en: {
		hi: 'Hi',
		pd: 'Personal Details',
		purchases: 'Purchases',
		station: 'Distribution Stations',
		stationM: 'Station Management',
		associationM: 'Association Manangement'
	}
});

export default profileNavigationText;